const boxMessage = `
<div class="{{class_my}}{{class_system}}"><div class="avatar"><img src="{{avatar}}" alt=""></div><div class="message"><div class="text">{{text}}</div><div class="time">{{time}}</div></div></div>
`;

export default boxMessage;